import React from 'react';
import { LOW_BALANCE_WARNING_MINUTES } from '../utils/callFormatUtils';

const CreatorCreditsNotifyModal = ({ open, onDismiss, minutesRemaining = null }) => {
  if (!open) return null;

  const roundedMinutes =
    Number.isFinite(minutesRemaining) && minutesRemaining > 0
      ? Math.max(1, Math.round(minutesRemaining))
      : LOW_BALANCE_WARNING_MINUTES;
  const minuteWord = roundedMinutes === 1 ? 'minute' : 'minutes';

  return (
    <div className="cm_creator_credits_notify_overlay" role="presentation">
      <div
        className="cm_creator_credits_notify_card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cm_creator_credits_notify_title"
      >
        <div className="cm_creator_credits_notify_icon" aria-hidden>
          <i className="fa-solid fa-triangle-exclamation" />
        </div>
        <h2 id="cm_creator_credits_notify_title" className="cm_creator_credits_notify_title">
          Subscriber running low on credits
        </h2>
        <p className="cm_creator_credits_notify_body">
          Your subscriber has about {roundedMinutes} {minuteWord} of call credits remaining. Ask them
          to add more credits to continue the call.
        </p>
        <button type="button" className="cm_creator_credits_notify_btn" onClick={onDismiss}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default CreatorCreditsNotifyModal;
